<template>
  <div class="fit-content">
    <div>
      <DataTableDeCrud
        :items="naturezas"
        :headers="headers"
        :rotina-id="ID_TELA_DE_NATUREZA"
        :configurar="false"
        :loading="loading"
        @create="() => abrirDialogCriarNatureza()"
        @update="(indice) => abrirDialogEditarNatureza(indice)"
        @delete="(indice) => openDialogDeleteNatureza(indice)"
      />
      <DialogDeEdicaoDeNatureza
        :operacao="operacao"
        :show-dialog.sync="showDialogParam"
        :natureza-param="naturezaParam"
        :itens="itensParam"
        @confirmado="atualizarNatureza"
      />
      <SnackbarMessage
        :show-snack.sync="snackbar.showSnackParam"
        :snack-text="snackbar.snackTextParam"
        :snack-type="snackbar.snackTypeParam"
      />

      <v-dialog v-model="dialogDeleteNatureza" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text refs="naturezaDelete">
            Tem certeza que deseja excluir a Natureza <b> {{ naturezaDelete.descricao }} </b>?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogDeleteNatureza = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="removerNatureza">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import NaturezaService from '../../../services/natureza/natureza'
import SnackbarMessage from '../../../components/SnackbarMessage'
import DialogDeEdicaoDeNatureza from '../../../components/natureza/DialogDeEdicaoDeNatureza'
import DataTableDeCrud from '../../../components/DataTableDeCrud'
import SnackBar from '../../../models/components/snackbar'
import Natureza from '../../../models/natureza'
import { ID_TELA_DE_NATUREZA } from '@/common/constants'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeEdicaoDeNatureza
  },
  data: () => ({
    name: 'TelaDeNatureza',
    headers: [
      { text: 'Código', value: 'codigo' },
      { text: 'Descrição', value: 'descricao' },
      { text: 'Entrada / Saída', value: 'tipoMovimento' }
    ],
    naturezas: [],
    loading: false,
    validForm: false,
    dialog: false,
    operacao: '',
    showDialogParam: false,
    naturezaParam: new Natureza(),
    itensParam: {},
    snackbar: new SnackBar(),
    dialogDeleteNatureza: false,
    naturezaDelete: new Natureza(),
    indiceNaturezaDelete: 0,
    ID_TELA_DE_NATUREZA: ID_TELA_DE_NATUREZA
  }),

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      try {
        if (this.$route.query.id) {
          NaturezaService.buscarPeloId(this.$route.query.id).then((response) =>
            this.naturezas.push(response)
          )
        } else {
          this.loadNaturezas()
        }
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível encontrar Naturezas cadastradas.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async loadNaturezas() {
      this.loading = true
      const response = await NaturezaService.buscarTodas()
      this.naturezas = response.map((item) => ({
        ...item
      }))
      this.loading = false
    },

    atualizarNatureza(natureza) {
      if (!natureza) return

      const indice = this.naturezas.findIndex(
        (naturezaExistente) => naturezaExistente.id === natureza.id
      )
      if (indice === -1) {
        this.naturezas.push(natureza)
        this.snackbar.snackTextParam = 'Natureza criada com sucesso.'
      } else {
        this.naturezas.splice(indice, 1, natureza)
        this.snackbar.snackTextParam = 'Natureza atualizada com sucesso.'
      }

      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    openDialogDeleteNatureza(indice) {
      this.naturezaDelete = this.naturezas[indice]
      if (!this.naturezaDelete.id) return

      this.indiceNaturezaDelete = indice
      this.dialogDeleteNatureza = true
    },

    async removerNatureza() {
      try {
        await NaturezaService.deleteById(this.naturezaDelete.id)
        this.snackbar.snackTextParam = 'Natureza removida com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.naturezas.splice(this.indiceNaturezaDelete, 1)
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
      this.dialogDeleteNatureza = false
    },

    abrirDialogCriarNatureza() {
      this.operacao = 'adicionar'
      this.itensParam = {}
      this.naturezaParam = new Natureza()
      this.showDialogParam = true
    },

    abrirDialogEditarNatureza(indice) {
      this.operacao = 'editar'
      this.itensParam = {}
      this.naturezaParam = { ...this.naturezas[indice] }
      this.showDialogParam = true
    }
  }
}
</script>
